import NationAvatar from "@/components/NationAvatar";
import {
  Box,
  styled,
  useTheme
} from "@mui/material";
import { useSelector } from "react-redux";

const StyledNationAvatar = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '0px',
  right: '0',
  'img': {
    display: 'block !important',
  }
}));

export default function UserAvatar({ size, nationSize, fontSize, onClick }) {
  const { user } = useSelector(state => state.user);
  const theme = useTheme();

  return (
    <Box sx={{
      background: 'var(--rp-palette-background-avatar)',
      borderRadius: '100%',
      color: 'var(--rp-palette-primary-contrastText) !important',
      fontWeight: 500,
      fontSize: `${fontSize ?? '18'}px`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      width: size,
      height: size,
      textAlign: 'center',
      lineHeight: `${size}px`,
      cursor:"pointer"
    }} onClick={onClick}>
      {user?.username && user?.username.slice(0, 1).toUpperCase()}
      <StyledNationAvatar>
        <NationAvatar code={user?.kycNationCode2} size={`${nationSize ?? '16'}px`} />
      </StyledNationAvatar>
    </Box>
  );
}
